var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react'; // tslint:disable-line

import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('image-bubble');
import { breakpoints } from '@shapeable/theme';
import { Image } from './image';
export var ImageBubbleDefaultProps = {
  size: 50,
  responsive: false,
  multipliers: {
    base: 1.0,
    landscape: 1.0,
    tablet: 1.25,
    desktop: 1.5
  },
  calc: function calc(size, multipliers, breakpoint) {
    var multipler = multipliers[breakpoint] || 1.0;
    return Math.round(multipler * size);
  }
}; // -------- Styles -------->

/**
 * Generates variable size styles based on the breakpoint name
 * @param name the breakpoint name
 */

var sizeFor = function sizeFor(name) {
  return function (_a) {
    var calc = _a.calc,
        multipliers = _a.multipliers,
        size = _a.size,
        responsive = _a.responsive;

    if (!size) {
      return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 100%;\n      width: 100%;\n      border-radius: 50%;\n    "], ["\n      height: 100%;\n      width: 100%;\n      border-radius: 50%;\n    "])));
    }

    var calcSize = responsive ? calc(size, multipliers, name) : size;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", "px;\n    width: ", "px;\n    border-radius: ", "px;\n  "], ["\n    height: ", "px;\n    width: ", "px;\n    border-radius: ", "px;\n  "])), calcSize, calcSize, calcSize);
  };
};

var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    overflow: hidden;\n    flex-shrink: 0;\n\n    img {\n      border-radius: 50%;\n    }\n  "], ["\n    ", "\n    overflow: hidden;\n    flex-shrink: 0;\n\n    img {\n      border-radius: 50%;\n    }\n  "])), sizeFor('base')),
  landscape: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), sizeFor('landscape')),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), sizeFor('tablet')),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), sizeFor('desktop'))
});
var ImageStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    height: 100%;\n  "], ["\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    height: 100%;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(Image)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var ImageBubble = function ImageBubble(props) {
  var className = props.className,
      image = props.image,
      size = props.size,
      onClick = props.onClick,
      calc = props.calc,
      responsive = props.responsive,
      multipliers = props.multipliers;

  if (!image) {
    throw new Error("ImageBubble component requires an image entity to render correctly");
  }

  return React.createElement(My.Container, {
    onClick: onClick,
    responsive: responsive,
    calc: calc,
    multipliers: multipliers,
    size: size,
    className: cls.name(className)
  }, React.createElement(My.Image, {
    image: image
  }));
};
ImageBubble.defaultProps = ImageBubbleDefaultProps;
ImageBubble.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;